// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"378da692","239":"33b9f86c","732":"84c3adba"}[chunkId] + ".chunk.js";
};